var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconDeviceTabletMenu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 2C2 0.895432 2.89543 0 4 0L15 0C16.1046 0 17 0.895431 17 2V18C17 19.1046 16.1046 20 15 20H4C2.89543 20 2 19.1046 2 18V2ZM4 17V3H15V17H4Z",
    fill: "#647FB4"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDeviceTabletMenu);
export default __webpack_public_path__ + "static/media/icon-device-tablet-menu.01e49aee317a36c353bac3c821e8217d.svg";
export { ForwardRef as ReactComponent };